<template>
  <div id="nav">
    <section class="no-vertical-padding">
      <div class="section-inner">
        <div class="nav-bar">
          <router-link :to="{ name: 'home' }" class="home-link">
            <!-- <logo/> -->
            <img src="./images/falcon.svg">
            <h6 class="h4">Fantasy Falcon</h6>
          </router-link>
          <button class="btn burger text" @click="hideNav = !hideNav">Menu</button>
        </div>
        <div @click="hideNav = true" :class="{'mobile-hide': hideNav}" class="menu">
          <div class="nav-block">
            <router-link :class="{'current': $route.name === 'weeks' }" v-if="loggedIn" :to="{ name: 'weeks' }">Stats</router-link>
            <router-link v-else :to="{ name: 'home' }">Home</router-link>
          </div>
          <!-- <div class="nav-block">
            <router-link :to="{ name: 'poll' }">Request a feature</router-link>
          </div> -->
          <div class="nav-block" >
            <router-link :to="{ name: 'alerts' }">Alerts</router-link>
            <span class="green-alert">New!</span>
          </div>
          <div class="nav-block">
            <router-link :to="{ name: 'contact' }">Contact</router-link>
          </div>
          <div class="nav-block">
            <router-link :to="{ name: 'about' }">About</router-link>
          </div>
          <div class="nav-block">
            <router-link :to="{ name: 'faq' }">FAQ</router-link>
          </div>
          <div class="nav-block">
            <router-link v-if="loggedIn" class="btn dark" :to="{ name: 'profile' }">Profile</router-link>
            <button v-else class="btn dark" @click="login()">Log in</button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>

// import logo from '@/components/logo/logo'
export default {
  name: 'site-nav',
  data () {
    return {
      hideNav: true
    }
  },
  // components: {
  //   'logo': logo
  // },
  mounted: function () {
  },
  computed: {
    loggedIn: function () {
      return this.$store.getters.isLoggedIn
    }
  },
  methods: {
    login: function () {
      this.$store.dispatch('login')
    }
  }
}
</script>
<style src="./nav.styl" lang="stylus" scoped></style>
